module.exports = __webpack_public_path__ + "static/media/bg3.96150655.jpg";